/**
 * DEV-ONLY demo mode for the notification bell.
 *
 * Lets anyone preview the notification panel with realistic example data
 * without waiting for real backend events (profile match runs, mentions, …):
 *
 *   http://localhost:3000/?notifDemo=1   → demo on (persisted in localStorage)
 *   http://localhost:3000/?notifDemo=0   → demo off
 *
 * Hard-gated to dev builds via import.meta.env.DEV — this can never activate
 * in a production bundle. While active, NotificationContext serves the items
 * below instead of calling the BFF, and mark-read/clear act on them locally.
 */
const DEMO_FLAG_KEY = 'tendera-notif-demo';

// Sync the flag from the URL once per page load.
try {
    if (typeof window !== 'undefined') {
        const param = new URLSearchParams(window.location.search).get('notifDemo');
        if (param === '1') localStorage.setItem(DEMO_FLAG_KEY, '1');
        else if (param === '0') localStorage.removeItem(DEMO_FLAG_KEY);
    }
} catch {
    /* localStorage unavailable — demo simply stays off */
}

export const isNotificationDemoMode = () => {
    try {
        return Boolean(import.meta.env.DEV) && localStorage.getItem(DEMO_FLAG_KEY) === '1';
    } catch {
        return false;
    }
};

const minutesAgo = (mins) => new Date(Date.now() - mins * 60000).toISOString();

/**
 * Six example notifications covering every type the panel renders:
 * three unread (→ "Uudet" group + badge count 3) and three read
 * (→ "Aiemmat" group). Texts render through the real i18n templates,
 * so they localize with the app language.
 */
export const getDemoNotifications = () => [
    {
        id: 'demo-1',
        type: 'PROFILE_MATCHES',
        params: { count: 38, agentName: 'Taloushallinnon palvelut', linkPath: '/my-profiles' },
        createdAt: minutesAgo(35),
        readAt: null,
    },
    {
        id: 'demo-2',
        type: 'MENTION',
        params: {
            actorName: 'Sanna Myyjä',
            noticeTitle: 'Koulukyytihankinta – Kruunupyyn kunta',
            commentText: 'Ehditkö katsoa tämän tarjouspyynnön liitteet ennen perjantaita?',
            linkPath: '/mybids',
        },
        createdAt: minutesAgo(2 * 60),
        readAt: null,
    },
    {
        id: 'demo-3',
        type: 'TEAM_BID_ASSIGNED',
        params: { actorName: 'Petri Martikainen', noticeTitle: 'IT-konsultointi – Väylävirasto', linkPath: '/mybids' },
        createdAt: minutesAgo(3 * 60),
        readAt: null,
    },
    {
        id: 'demo-4',
        type: 'DECISION_MATCHES',
        params: { count: 1, agentName: 'Svenska budgetar', linkPath: '/decisions' },
        createdAt: minutesAgo(12 * 60),
        readAt: minutesAgo(10 * 60),
    },
    {
        id: 'demo-5',
        type: 'PROFILE_MATCHES',
        params: { count: 2, agentName: 'Onboarding-profiili', linkPath: '/my-profiles' },
        createdAt: minutesAgo(26 * 60),
        readAt: minutesAgo(20 * 60),
    },
    {
        id: 'demo-6',
        type: 'INVITE_ACCEPTED',
        params: { memberEmail: 'kollega@yritys.fi', organizationName: 'Tendera Demo Oy', linkPath: '/settings/team' },
        createdAt: minutesAgo(2 * 24 * 60),
        readAt: minutesAgo(30 * 60),
    },
];
